import Vue from 'vue'

import App from './App.vue'

import axios from 'axios'
import VueAxios from 'vue-axios'

import router from './router'
import store from './store'

import Vuelidate from 'vuelidate'

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

import AOS from 'aos';
import 'aos/dist/aos.css';

import './assets/scss/style.scss';

import 'rfs/scss.scss'

Vue.config.productionTip = false

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(Vuelidate)
Vue.use(VueAxios, axios)

new Vue({
    router,
    store,
    created() {
        AOS.init()
    },
    render: h => h(App)
}).$mount('#app')